// Libraries
import { useBreakpointValue } from '@chakra-ui/react';
import { FC, ReactElement } from 'react';
// Components
import { CustomDrawer, CustomModal } from './Components';
// Types
import { AdaptableDialogProps } from './AdaptableDialog.types';

/**
 * A versatile dialog component that adapts to different screen sizes and can be used either as a drawer or a modal.
 *
 * @component
 * @param {AdaptableDialogProps} props - The props for the AdaptableDialog component.
 * @returns {ReactElement} The AdaptableDialog component.
 */
export const AdaptableDialog = ({ children, buttonContent }: AdaptableDialogProps): ReactElement => {
  const Wrapper = useBreakpointValue<FC<AdaptableDialogProps>>({ base: CustomDrawer, md: CustomModal }) ?? CustomDrawer;

  return <Wrapper buttonContent={buttonContent}>{children}</Wrapper>;
};
